"use strict";

exports.__esModule = true;
exports.ElementEditorDragLayer = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDnd = require("react-dnd");
var _ElementEditorDragPreview = require("./ElementEditorDragPreview");
var _dec, _class, _ElementEditorDragLayer;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var layerStyles = {
  position: "fixed",
  pointerEvents: "none",
  zIndex: 100,
  left: 0,
  top: 0,
  width: "100%",
  height: "100%"
};
function getItemStyles(props) {
  var initialOffset = props.initialOffset,
    currentOffset = props.currentOffset;
  if (!initialOffset || !currentOffset) {
    return {
      display: "none"
    };
  }
  var x = currentOffset.x,
    y = currentOffset.y;
  var transform = "translate(" + x + "px, " + y + "px)";
  return {
    background: "rgba(0, 0, 0, 0.1)",
    transform: transform,
    WebkitTransform: transform
  };
}
var ElementEditorDragLayer = exports.ElementEditorDragLayer = (_dec = (0, _reactDnd.DragLayer)(function (monitor) {
  return {
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging()
  };
}), _dec(_class = (_ElementEditorDragLayer = /*#__PURE__*/function (_Component) {
  function ElementEditorDragLayer() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(ElementEditorDragLayer, _Component);
  var _proto = ElementEditorDragLayer.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      item = _this$props.item,
      itemType = _this$props.itemType,
      isDragging = _this$props.isDragging;
    if (!isDragging) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: layerStyles
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: getItemStyles(this.props)
    }, this.renderItem(itemType, item)));
  };
  _proto.renderItem = function renderItem(itemType, item) {
    switch (itemType) {
      case "element":
        return /*#__PURE__*/_react["default"].createElement(_ElementEditorDragPreview.ElementEditorDragPreview, {
          type: item.element.type,
          width: item.element.props.width,
          height: item.element.props.height,
          render: this.props.render
        });
      case "widget":
        return /*#__PURE__*/_react["default"].createElement(_ElementEditorDragPreview.ElementEditorDragPreview, {
          type: item.widget.name,
          width: item.widget.propConstraints.width["default"],
          height: item.widget.propConstraints.height["default"],
          render: this.props.render
        });
      default:
        return null;
    }
  };
  return ElementEditorDragLayer;
}(_react.Component), _ElementEditorDragLayer.defaultProps = {
  item: undefined,
  itemType: undefined,
  initialOffset: undefined,
  currentOffset: undefined,
  isDragging: undefined
}, _ElementEditorDragLayer)) || _class);